import React from 'react'

import { compose } from 'recompose'
import styled, { css, keyframes } from 'styled-components'

import { style } from 'theme'

type Props = {
  values: string[]
}

const fadeout = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`

const fadein = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1
  }
`

const drop = keyframes`
from {
  margin-top: -8px;
}

to {
  margin-top: 10px;
}
`

const firstElementAnimation = css`
  ${drop} 0.4s ease-in-out 1s forwards, ${fadeout} 0.3s ease-in 1s forwards;
`

const otherElementAnimation = props => css<{ index: number }>`
  ${fadein} 0.4s ease-in ${props.index + 0.3}s forwards, ${drop} 0.3s ease-in-out ${props.index +
  1}s forwards,
    ${fadeout} 0.3s ease-in ${props.index + 1}s forwards;
`

const animation = props => css<{ index: number }>`
  animation: ${props.index === 0 ? firstElementAnimation : otherElementAnimation};
`

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
`

const RotatingText = styled.p<{ index: number }>`
  color: ${style(theme => theme.colors.slate)};
  font-size: 14px;
  text-align: center;
  margin: -8px 0 0 0;
  width: 100%;
  left: 40%;
  transform: translateX(-50%);
  opacity: 0;
  ${animation};
  position: absolute;
  &:first-child {
    opacity: 1;
  }
`

const enhance = compose<Props, Props>()

const CascadingText = props => (
  <Container>
    {props.values.map((value, index) => (
      <RotatingText key={index} index={index}>
        {value}
      </RotatingText>
    ))}
  </Container>
)

export default enhance(CascadingText)
